import React from 'react';
import classNames from 'classnames';
import './marker.scss';

const Marker = props => {
    return (
        <div className={classNames({
            'marker': true,
            'marker--is-active': props.marker && props.currentActiveMarker === props.marker.id
        })}>{props.marker && props.marker.logo && <div className="marker__logo"><img src={props.marker.logo} alt="" /></div>}</div>
    );
};

export default Marker;